export enum AutoRenewType {
    Disabled = 0,
    OptIn = 1,
    OptOut = 2,
    AutoPayRequired = 3,
    AdminInitiated = 4,
}